module.exports = __webpack_public_path__ + "static/media/money.c836ae98.png";